import { useNavigate, useLocation } from 'react-router-dom';

const tabs = [
  { path: '/', label: '今日', icon: 'ri-sun-line', activeIcon: 'ri-sun-fill' },
  { path: '/todo', label: '待办', icon: 'ri-checkbox-circle-line', activeIcon: 'ri-checkbox-circle-fill' },
  { path: '/projects', label: '项目', icon: 'ri-folder-line', activeIcon: 'ri-folder-fill' },
  { path: '/finance', label: '财经', icon: 'ri-funds-line', activeIcon: 'ri-funds-fill' },
  { path: '/profile', label: '我的', icon: 'ri-user-line', activeIcon: 'ri-user-fill' },
];

export default function BottomNavigation() {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-background-50 border-t border-background-200/70"
      style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}>
      <div className="flex items-center justify-around h-14 px-1 max-w-lg mx-auto">
        {tabs.map((tab) => {
          const active = isActive(tab.path);
          return (
            <button
              key={tab.path}
              onClick={() => navigate(tab.path)}
              className="flex flex-col items-center justify-center flex-1 h-full transition-colors duration-150 cursor-pointer whitespace-nowrap"
            >
              <span className={`w-5 h-5 flex items-center justify-center text-lg ${active ? 'text-primary-600' : 'text-foreground-400'}`}>
                <i className={active ? tab.activeIcon : tab.icon}></i>
              </span>
              <span className={`text-[10px] mt-0.5 font-medium ${active ? 'text-primary-600' : 'text-foreground-400'}`}>
                {tab.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}